<template>
    <div class="btns mt-4">
        
        <!--Others Profile Actions-->
        <template v-if="!isProfileMine">

            <!--Send Friend Request-->
            <a v-if="!isFriendsWithMe.isFriends && isFriendsWithMe.status === 'notFriends'" href="#0" class="btn green icon-left" @click.prevent="friendRequest('add')">
                <ion-icon name="person-add"></ion-icon> Add Friend
            </a>

            <!--Accept or Delete Friend Request-->
            <a v-if="!isFriendsWithMe.isFriends && isFriendsWithMe.status === 'friendRequestSent'" href="#0" class="btn secondary icon-left" @click.prevent="friendRequest('cancel')">
                <ion-icon name="person-remove"></ion-icon> Cancel Request
            </a>

            <a v-if="!isFriendsWithMe.isFriends && isFriendsWithMe.status === 'friendRequestReceived'" href="#0" class="btn green icon-left" @click.prevent="friendRequest('approve')">
                <ion-icon name="person-add"></ion-icon> Approve
            </a>
            <a v-if="!isFriendsWithMe.isFriends && isFriendsWithMe.status === 'friendRequestReceived'" href="#0" class="btn secondary icon-left" @click.prevent="friendRequest('cancel')">
                <ion-icon name="person-remove"></ion-icon> Delete
            </a>

            <!--Send Message-->
            <a href="#0" class="btn secondary icon-only hint hint--top" data-hint="Send Message" @click.prevent="sendMessage()">
                <ion-icon name="chatbox-ellipses"></ion-icon>
            </a>
            
        </template>

        <!--My profile actions-->
        <template v-else>
            <a 
                href="#0"
                class="btn secondary icon-only hint hint--top"
                data-hint="Settings"
                @click.prevent="$emit('change-tab', 'Settings')"
            >
                <ion-icon name="settings"></ion-icon>
            </a>
        </template>

        <router-link v-if="!hideProfile" :to="`/user/${member.uid}`" class="btn secondary icon-only hint hint--top" data-hint="View Profile">
            <ion-icon name="person-circle"></ion-icon>
        </router-link>

        <template v-if="!isProfileMine">

            <!--More Menu-->
            <details v-if="isFriendsWithMe.isFriends && isFriendsWithMe.status === 'friends'" class="dropdown details-reset details-overlay d-inline-block moreMenu">
                <summary class="d-inline" aria-haspopup="true">
                    <a class="btn secondary icon-only hint hint--top moreIcon" data-hint="More">
                        <ion-icon name="ellipsis-horizontal"></ion-icon>
                    </a>
                </summary>
                <ul class="dropdown-menu dropdown-menu-s">
                    <li>
                        <router-link :to="`/user/${member.uid}`" class="dropdown-item">
                            <ion-icon name="person-circle"></ion-icon> View Profile
                        </router-link>
                    </li>
                    <li>
                        <a href="#0" class="dropdown-item" @click.prevent="sendMessage()">
                            <ion-icon name="chatbox-ellipses"></ion-icon> Send Message
                        </a>
                    </li>
                    <li>
                        <a href="#0" class="dropdown-item" @click.prevent="friendRequest('unfriend')">
                            <ion-icon name="person-remove"></ion-icon> Unfriend
                        </a>
                    </li>
                    <li>
                        <a href="#0" class="dropdown-item">
                            <ion-icon name="person-remove"></ion-icon> Block
                        </a>
                    </li>
                </ul>
            </details>

        </template>

    </div>    
</template>

<script>
const fb = require('@/firebaseConfig.js')

export default {
    data(){
        return{
            isFriends: false,
            friendStatus: 'notFriends'
        }
    },

    props: {
        member: Object,
        hideProfile: Boolean
    },

    computed: {
        isProfileMine(){
            if(this.$store.state.currentUser !== null && this.member !== null){
                if(this.member.uid === this.$store.state.currentUser.uid){
                    return true
                }
            }
            return false
        },
        isFriendsWithMe(){
            if(this.$store.state.currentUser !== null){
                let findFriend = this.$store.getters.isUserInMyFriend(this.member.uid)

                if(findFriend.length > 0){
                    return findFriend[0]
                }else{
                    return {
                        isFriends: false,
                        status: 'notFriends'
                    }
                }
            }
            return false
        }
    },

    methods: {
        friendRequest(action){
            if(!this.$store.state.currentUser){
                alert('Please login first!')
                return
            }
            if(!this.member.uid){
                alert('Error getting friend uid!')
                return
            }

            let friendData = this.member
            let friendUid = this.member.uid

            let userUid = this.$store.state.currentUser.uid
            let userFriendsRef = fb.usersCollection.doc(userUid).collection('friends').doc(friendUid)
            let friendFriendsRef = fb.usersCollection.doc(friendUid).collection('friends').doc(userUid)
            let userAllFriends = this.$store.state.userProfileFriends

            let isFriends = false
            let userFriendStatus = ''
            let friendFriendStatus = ''
            let notifyAction = ''

            // Add Friend Request
            if(action === 'add'){

                isFriends = false
                userFriendStatus = 'friendRequestReceived'
                friendFriendStatus = 'friendRequestSent'
                notifyAction = 'sent'

            // Accept Friend Request
            }else if(action === 'approve'){

                isFriends = true
                userFriendStatus = 'friends'
                friendFriendStatus = 'friends'
                notifyAction = 'approved'

            // Cancel Friend Request
            }else if(action === 'cancel'){

                isFriends = false
                userFriendStatus = 'notFriends'
                friendFriendStatus = 'notFriends'

            // Unfriend
            }else if(action === 'unfriend'){

                isFriends = false
                userFriendStatus = 'notFriends'
                friendFriendStatus = 'notFriends'
            }

            // Update data
            let userUpdates = {
                isFriends: isFriends,
                status: userFriendStatus,
                timestamp: fb.firebase.firestore.FieldValue.serverTimestamp()
            }
            let friendUpdates = {
                isFriends: isFriends,
                status: friendFriendStatus,
                timestamp: fb.firebase.firestore.FieldValue.serverTimestamp()
            }

            // DB Action & Notifications
            userFriendsRef.set(friendUpdates, {merge: true}).then(doc1 => {
                friendFriendsRef.set(userUpdates, {merge: true}).then(async(doc2) => {

                    console.log(`Friend request ${notifyAction} to ${friendData.displayName} successfully!`)

                    if(notifyAction !== ''){
                        await this.addNewActivity({
                            friendUid: friendUid,
                            action: notifyAction
                        })
                    }
                })
            })
        },
        
        sendMessage(){
            if(!this.$store.state.currentUser){
                alert('Please login first to send message.')
                return
            }
            if(!this.member.uid){
                alert('Error getting friend uid!')
                return
            }

            this.$router.push(`/chat?user=${this.member.uid}`)
        },

        async addNewActivity(data){

            let receiverId = data.friendUid
            let userNotificationRef = fb.db.collection('users').doc(receiverId).collection('notifications')
            let senderId = this.$store.state.currentUser.uid
            let path = `/user/${senderId}`
            let type = 'friendRequest'

            let newActivity = {
                timestamp: fb.firebase.firestore.FieldValue.serverTimestamp(),
                uid: senderId,
                message: `sent you a friend request.`,
                path: path,
                to: receiverId,
                type: type,
                itemId: data.action,
                seen: false
            }

            await userNotificationRef.add(newActivity).then(doc => {
                console.log('New activity created with id: ', doc.id)
            }).catch(err => {
                console.log('Error creating new activity: ', err)
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/MemberActions.vue